import { getBoxValue } from './Const/functions';

const Style = ({ attributes, clientId }) => {

	const { titleTypo, titleColor, descTypo, descColor, titleMargin, descMargin, arrow, indicator, SliderOverly, height, borderRadius, position, arrowWidth, arrowHeight, arrowRadius } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#bsbCarousel-${clientId} h5{
			${titleTypo?.styles || 'font-size: 25px;'}
			color: ${titleColor};
			margin: ${getBoxValue(titleMargin)};
		}
		#bsbCarousel-${clientId} p {
			${descTypo?.styles || 'font-size: 20px;'}
			color: ${descColor};
			margin: ${getBoxValue(descMargin)};
			 
		} 
		#bsbCarousel-${clientId} .carousel-item {
			height: ${height};
			border-radius: ${getBoxValue(borderRadius)};
    		box-sizing: border-box;
    		overflow: hidden;
		}

		#bsbCarousel-${clientId} .bsbButtonDesign .bsbArrowButton {
			font-size:${arrow?.size}px;
			${arrow?.styles || 'color: #333; background: #transparent;'};
			width:${arrowWidth};
			height:${arrowHeight};
			border-radius:${getBoxValue(arrowRadius)};
		}

		#bsbCarousel-${clientId} .bsbButtonDesign .bsbArrowButton svg{
			fill:${arrow.color};
		}
 
		#bsbCarousel-${clientId} .carousel-item{
			position:relative;
		}

		#bsbCarousel-${clientId} .carousel-item:after{
			content: '';
			width: 100%;
			height: 100%;
			top: 0;
			position: absolute;
			left: 0;
			background: ${SliderOverly};
		}
		#bsbCarousel-${clientId} .carousel-indicators button {
			width: ${indicator?.width} !important;
			height: ${indicator?.height} !important;
			border-radius: ${indicator?.radius};
		}

		#bsbCarousel-${clientId} .carousel-indicators button{
			background-color:${indicator.color}
		}

		#bsbCarousel-${clientId} .carousel-indicators button.active{
			background-color:${indicator.activeColor};
		}

		#bsbCarousel-${clientId} .carousel-caption.bsbContentMiddle{
			top: ${position?.top}
		}
		
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;